
import React from "react";
import { QRCodeSVG } from "qrcode.react";
import "./QRCodeGenerator.css";

export default function QRCodeGenerator({
    value,
    size = 200,
    title = "QR Code"
}) {
    if (!value) return null;

    return (
        <div className="qr-code">
            <QRCodeSVG
                value={value}
                size={size}
                level="M"
                marginSize={2}
                title={title}
            />
        </div>
    );
}
